<div class="box-eventos-mapa__iframe">
    <agm-map [latitude]="travelEvents.lat" [longitude]="travelEvents.lon" [zoom]="14" width="100%" [mapDraggable]="false" [draggableCursor]="true">
        <agm-marker [latitude]="travelEvents.lat" [longitude]="travelEvents.lon">
            <agm-info-window #infowindow [isOpen]="true">
                <h4 class="text-center"><strong>{{travelEvents.eventType}}</strong></h4>
                <div class="box-mini__content-valores">
                    <strong>Fecha: </strong><span class="cyan">{{travelEvents.timeStamp}}</span>
                </div>
                <div class="box-mini__content-valores">
                    <strong>Duracion: </strong><span class="cyan">{{travelEvents.duration}}</span>
                </div>
                <div class="box-mini__content-valores">
                    <strong>Descripcion: </strong><span class="cyan">{{travelEvents.description}}</span>
                </div>
            </agm-info-window>
        </agm-marker>
    </agm-map>
</div>
